import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import cx from "classnames";
import React from "react";

import { AutopilotApiKey } from "services/AutopilotService";

import styles from "../ProfilePage.module.scss";

interface ApiKeysTableProps {
  apiKeys: AutopilotApiKey[];
  deleteLoadingPrefix: string | null;
  onDelete: (prefix: string) => void;
}

const formatCreatedDate = (created: string) =>
  created
    ? new Date(created).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "—";

const ApiKeysTable: React.FC<ApiKeysTableProps> = ({
  apiKeys,
  deleteLoadingPrefix,
  onDelete,
}) => {
  if (apiKeys.length === 0) return null;

  return (
    <div className={styles.apiKeysTable}>
      <div className={styles.apiKeysTableHeader}>
        <span>Label</span>
        <span>Key</span>
        <span>Created At</span>
        <span>Status</span>
        <span>Actions</span>
      </div>

      {apiKeys.map((key) => (
        <div
          key={key.prefix}
          className={cx(
            styles.apiKeysTableRow,
            key.revoked && styles.apiKeysTableRowRevoked,
          )}
        >
          <span className={styles.apiKeysTableLabel}>{key.name}</span>
          <div className={styles.apiKeysTableKey}>
            <span className={styles.apiKeysTablePrefix}>
              {key.prefix}••••••••••••••••
            </span>
          </div>
          <span className={styles.apiKeysTableCreated}>
            {formatCreatedDate(key.created)}
          </span>
          <span>
            <span
              className={cx(
                styles.apiKeysStatusBadge,
                key.revoked
                  ? styles.apiKeysStatusInactive
                  : styles.apiKeysStatusActive,
              )}
            >
              <span className={styles.apiKeysStatusDot} />
              {key.revoked ? "Inactive" : "Active"}
            </span>
          </span>
          <span>
            {!key.revoked && (
              <Tooltip title="Revoke key">
                <IconButton
                  size="small"
                  disabled={deleteLoadingPrefix === key.prefix}
                  onClick={() => onDelete(key.prefix)}
                  sx={{
                    color: "#9d9d9d",
                    background: "#2c2c3e",
                    borderRadius: "6px",
                    padding: "6px",
                    "&:hover": { color: "#ff7070" },
                  }}
                >
                  {deleteLoadingPrefix === key.prefix ? (
                    <CircularProgress size={14} sx={{ color: "#9d9d9d" }} />
                  ) : (
                    <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ApiKeysTable;
